module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    attrs: {
      "id": "flows-new"
    }
  }, [_c('router-link', {
    staticClass: "back-link-spaced",
    attrs: {
      "to": "/fluxos-de-cadencia"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.back')))]), _c('h1', [_vm._v(_vm._s(_vm.$t('flows.title.cadenceFlowNew')))]), _c('flow-form', {
    attrs: {
      "type_of_action": _vm.type_of_action,
      "save-text": _vm.$t('flows.actions.new'),
      "flow": _vm.flow
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8ccf7a8c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/flows/new.vue
// module id = 1185
// module chunks = 1